import { instance as axios } from "../axios";
import JWT from 'jsonwebtoken';

// initial state
const state = {
    data: [
        {
            id_tipo_acao: 1,
            nome: 'Ação inserida em Projeto de ED'
        },
        {
            id_tipo_acao: 2,
            nome: 'Ação inserida noutro tipo de projeto'
        },
        {
            id_tipo_acao: 3,
            nome: 'Ação não inserida em projeto'
        }
    ]
}

// getters
const getters = {
    getAll:(state)=>{
        return state.data;
    },
    getById: (state) => (id) => {
        if(!id) return;
        return state.data.find((el)=>{ return el.id_tipo_acao == id})
    }
}

const actions = {}

const mutations = {}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/tipos_acao.js